import { render, staticRenderFns } from "./VerticalAutocomplete.vue?vue&type=template&id=5034de2d"
import script from "./VerticalAutocomplete.vue?vue&type=script&lang=js"
export * from "./VerticalAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports